import React, { useEffect, useReducer, useState, useRef } from "react";

import Confetti from "react-confetti-boom";

import Header from "./GameHeader";
import Controls from "./Controls";
import GameBoard from "./GameBoard";
import WordList from "./WordList";


import { INITIAL_STATE, gameReducer } from "../reducers/gameReducer";

import { getAnagrams } from "../utils/anagram";

import { DrawCirclePoints } from "../utils/DrawCirclePoints";

import { RandomGameName } from "../utils/RandomGameName";

import { ShuffleArray } from "../utils/ShuffleArray";

export default function WordScapesGame({ coins }) {
  const [state, dispatch] = useReducer(gameReducer, INITIAL_STATE);
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [hintMessage, setHintMessage] = useState("");
  const [mouseDown, setMouseDown] = useState(false);
  const menuRef = useRef(null);
  const tapSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/tap.mp3`)
  );

  const confettiSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/confetti.mp3`)
  );

  const amazingSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/clapping.mp3`)
  );

  const excellentSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/clapping.mp3`)
  );

  const goodSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/clapping.mp3`)
  );

  const niceSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/clapping.mp3`)
  );

  const alreadyFoundSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/alreadyfound.mp3`)
  );

  const notEnoughCoinsSound = useRef(
    new Audio(`${process.env.PUBLIC_URL}/assets/sounds/notenoughcoins.mp3`)
  );

  useEffect(() => {
    setupGame(RandomGameName());
  }, []);

  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
    .vidya-toggle {
      display: none !important;
    }
  `;

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  /* async function setupGame(word) {
    const result = await getAnagrams(word);

    word = result[0];

    const validWords = result[1].all
      .map((w) => w.toUpperCase())
      .filter((w) => w.length > 2);

    const generated = DrawCirclePoints(
      word,
      27,
      { x: 50, y: 50 }
    );

    dispatch({
      type: 'SET_GAME',
      payload: {
        letters: generated.letters,
        points: generated.points,
        validWords,
      },
    });
  } */

  async function setupGame(word) {
    setLoading(true);
    try {
      const result = await getAnagrams(word);

      word = result[0];

      const validWords = result[1].all
        .map((w) => w.toUpperCase())
        .filter((w) => w.length >= 3);

      const generated = DrawCirclePoints(word, 27, { x: 50, y: 50 });

      dispatch({
        type: "SET_GAME",
        payload: {
          letters: generated.letters,
          points: generated.points,
          validWords,
        },
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  function playTapSound() {
    tapSound.current.currentTime = 0;
    tapSound.current.play().catch(() => { });
  }

  function playConfettiSound() {
    confettiSound.current.currentTime = 0;
    confettiSound.current.play().catch(() => { });
  }

  function playVoice(soundRef) {
    soundRef.current.currentTime = 0;
    soundRef.current.play().catch(() => { });
  }

  function startSelection(letter) {
    playTapSound();
    setMouseDown(true);

    dispatch({
      type: "SELECT_LETTER",
      payload: {
        id: letter.id,
        letter: letter.char,
      },
    });

    dispatch({
      type: "UPDATE_PATH",
      payload: {
        connected: `M ${letter.x} ${letter.y}`,
        connector: `M ${letter.x} ${letter.y}`,
      },
    });
  }

  function dragSelection(letter) {
    if (!mouseDown) return;
    if (!state.selectedLetters.includes(letter.id)) {
      playTapSound();
    }
    dispatch({
      type: "SELECT_LETTER",
      payload: {
        id: letter.id,
        letter: letter.char,
      },
    });

    dispatch({
      type: "UPDATE_PATH",
      payload: {
        connected: state.connectedPath + ` L ${letter.x} ${letter.y}`,

        connector: `M ${letter.x} ${letter.y}`,
      },
    });
  }

  /* function completeWord() {
    setMouseDown(false);

    if (state.validWords.includes(state.currentWord)) {
      dispatch({ type: "VALID_WORD" });
    }

    dispatch({ type: "RESET_SELECTION" });
  } */

  /* function completeWord() {

    setMouseDown(false);

    if (
      state.validWords.includes(state.currentWord)
    ) {

      dispatch({ type: "VALID_WORD" });

      setTimeout(() => {

        dispatch({
          type: "SHOW_CONFETTI",
        });

      }, 50);

      setTimeout(() => {

        dispatch({
          type: "HIDE_CONFETTI",
        });

      }, 2000);

    }

    dispatch({
      type: "RESET_SELECTION",
    });
  } */

  function completeWord() {

    setMouseDown(false);

    if (
      state.validWordsClone.includes(state.currentWord) &&
      !state.validWords.includes(state.currentWord)
    ) {

      dispatch({
        type: "SET_SUCCESS_MESSAGE",
        payload: "Already Found!",
      });

      setTimeout(() => {
        dispatch({
          type: "CLEAR_SUCCESS_MESSAGE",
        });
      }, 2000);

      dispatch({
        type: "RESET_SELECTION",
      });

      return;
    }

    if (
      state.validWords.includes(
        state.currentWord
      )
    ) {
      // LAST WORD CHECK
      const isLastWord =
        state.validWords.length === 1;

      let message = "";

      switch (state.currentWord.length) {
        case 6:
          message = "🌟 Amazing!";
          playVoice(amazingSound);
          break;

        case 5:
          message = "🎉 Excellent!";
          playVoice(excellentSound);
          break;

        case 4:
          message = "👍 Good!";
          playVoice(goodSound);
          break;

        case 3:
          message = "😊 Nice!";
          playVoice(niceSound);
          break;

        default:
          message = "";
      }

      dispatch({
        type: "SET_SUCCESS_MESSAGE",
        payload: message,
      });

      dispatch({
        type: "VALID_WORD",
      });

      setTimeout(() => {
        playConfettiSound();
        dispatch({
          type: "SHOW_CONFETTI",
        });

      }, 50);

      setTimeout(() => {

        dispatch({
          type: "HIDE_CONFETTI",
        });

        dispatch({
          type: "CLEAR_SUCCESS_MESSAGE",
        });

      }, 2000);

      // LEVEL UP
      if (isLastWord) {

        setTimeout(() => {

          dispatch({
            type: "LEVEL_UP",
          });

          setupGame(RandomGameName());

        }, 2500);

      }

    }

    dispatch({
      type: "RESET_SELECTION",
    });
  }



  function ShuffleLetters() {
    const shuffled = ShuffleArray(state.points);

    const updated = state.letters.map((letter, index) => ({
      ...letter,
      x: shuffled[index][0].x,
      y: shuffled[index][0].y,
    }));

    dispatch({
      type: "SHUFFLE",
      payload: updated,
    });
  }

  /*  function handleHint() {
     if (state.validWords.length === 0) return;
 
     console.log(state.validWords);
 
   } */

  /* function handleHint() {

  if (state.validWords.length === 0) return;

  const randomWord =
    state.validWords[
      Math.floor(Math.random() * state.validWords.length)
    ];

  console.log(randomWord);

} */

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("hintpopop");
    } else {
      document.body.classList.remove("hintpopop");
    }

    return () => {
      document.body.classList.remove("hintpopop");
    };
  }, [menuOpen]);


  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  function handleHint() {

    if (state.validWords.length === 0) return;

    if (state.coins < 5) {
      setHintMessage("Not enough coins!");
      return;
    }

    setHintMessage("");

    const randomWord =
      state.validWords[
      Math.floor(Math.random() * state.validWords.length)
      ];

    const randomIndex =
      Math.floor(Math.random() * randomWord.length);

    dispatch({
      type: "HINT_USED",
      payload: {
        word: randomWord,
        index: randomIndex,
      },
    });

  }

  return (
    <div className="" onPointerUp={completeWord}>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 vh-100 d-flex flex-column justify-content-center align-items-center"
          style={{ zIndex: 9999, background: "#000000d4" }}
        >
          <div
            className="spinner-border text-white mb-3"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <h5 className="text-white">Please Wait...</h5>
        </div>
      )}

      <div ref={menuRef} id="st-container" className={`st-container ${menuOpen ? "st-effect-1 st-menu-open" : ""}`}>
        <div className="st-menu st-effect-1"><h3>{hintMessage ? hintMessage : state.hintWord}</h3></div>
      </div>

      <div className="max-w-6xl mx-auto gredient-yellow">

        <Controls onShuffle={ShuffleLetters} onNewGame={() => setupGame(RandomGameName())} />
        <Header coins={state.coins} level={state.level} onHint={handleHint} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        <div className="row justify-content-center my-5">
          <div className="col-md-3 d-flex align-items-end">
            <WordList
              validWordsClone={state.validWordsClone}
              validWords={state.validWords}
            />
          </div>
          <div className="col-md-6 text-center">
            {/* <div className="text-center">{state.currentWord}</div> */}
            <GameBoard
              letters={state.letters}
              selectedLetters={state.selectedLetters}
              connectorPath={state.connectorPath}
              connectedPath={state.connectedPath}
              startSelection={startSelection}
              dragSelection={dragSelection}
            />
          </div>
          <div className="col-md-3 puzzle_boy_main">
            <img className='puzzle_boy' src={`${process.env.PUBLIC_URL}/assets/images/puzzle/boy.png`} alt="Boy Icon" />
            <div className="success_message">
              {state.successMessage && (
                <div className="success-message">
                  {state.successMessage}
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
      {state.showConfetti && <Confetti recycle={false} particleCount={550} colors={['#df623c', '#98f598']} />}
    </div>
  );
}
